import { render } from "./registerUser.vue?vue&type=template&id=7bce5d11&scoped=true"
import script from "./registerUser.vue?vue&type=script&lang=js"
export * from "./registerUser.vue?vue&type=script&lang=js"

import "./registerUser.vue?vue&type=style&index=0&id=7bce5d11&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bce5d11"]])

export default __exports__